import {Component, ElementRef, Input, OnDestroy, ViewChild} from '@angular/core';
import {SubscriberService} from "../../../services/subscriber.service";
import {MainPageBanner} from "../../../model/main-page-banner";
import {Router} from "@angular/router";

declare var $: any;

@Component({
  selector: 'app-main-page-banner',
  templateUrl: './main-page-banner.component.html',
  styleUrls: ['./main-page-banner.component.css']
})
export class MainPageBannerComponent implements OnDestroy {
  @Input() banners: ReadonlyArray<MainPageBanner>;

  private _bannerSlider: ElementRef;

  private sliderInit: boolean;

  constructor(private readonly subscriberService: SubscriberService,
              private readonly router: Router) {
    this.sliderInit = false;
  }

  @ViewChild("bannerSlider") set bannerSlider(value: ElementRef) {
    this.removeSlider();

    this._bannerSlider = value;
    this.initSlick();
  }


  initSlick(): void {
    if (!this.sliderInit && this._bannerSlider) {

      $('.main-slider__imgs').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'linear',
        asNavFor: '.main-slider__contents'
      });

      $('.main-slider__contents').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.main-slider__imgs',
        fade: true,
        cssEase: 'linear',
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
          {
            breakpoint: 1320,
            settings: {arrows: false, dots: true}
          },
          {
            breakpoint: 768,
            settings: {arrows: false, dots: true}
          }
        ]
      });

      this.sliderInit = true;
    }
  }

  removeSlider(): void {
    if (this.sliderInit && this._bannerSlider) {
      ($('.main-slider__imgs') as any).slick('unslick');
      ($('.main-slider__contents') as any).slick('unslick');
      this.sliderInit = false;
    }
  }

  ngOnDestroy(): void {
    this.removeSlider();
  }

  redirect(url: string) {
    if (url.includes("genres")) {
      let genreId = url.replace(/\D/g, '');
      this.router.navigate(['/genres'], {queryParams: {id: genreId}});
    } else {
      this.router.navigate([url]);
    }
  }

  getSongName(banner: MainPageBanner) {
    return banner.languageAttributes[0].title;
  }
}
